/**
 * @ndoc directive
 * @name v3sAnswer
 * @description
 * Antwortmöglichkeiten von MC- und SC-Aufgaben
 * Bindet die Inputs ng-model an das scope von v3sExercise über 'require' und Einbindung des Controllers
 * @memberOf v3sWbtPlayerApp:exercise:choice
 */
angular.module('v3sWbtPlayerApp').controller('v3sAnswerController', ["$scope", "$element", "v3sAnswerElement", "$tooltip", "v3sContentMediaPath", "v3sI18nService", "$document", function ($scope, $element, v3sAnswerElement, $tooltip, v3sContentMediaPath, v3sI18nService, $document) {
    $scope.answerElement = new v3sAnswerElement($scope.id);

    var answerElement = $scope.answerElement;
    var fod;
    var tooltip;

    var showFeedbackFunction = function (show) {

        if (answerElement.isFeedbackVisible()) {
            if (!!tooltip) {
                tooltip.hide();
                tooltip.setEnabled(false);

                $element.removeClass('wrong correct silent answer');
            }

            if (show !== false) {
                var status = answerElement.getStatus();
                var msg = v3sI18nService.getText([
                    "exercises.fod." + answerElement.type + "." + status.name,
                    "exercises.fod.general." + status.name
                ]);

                if (answerElement.completed) {
                    if (!!fod) {
                        msg += " " + fod;
                    }
                }

                tooltip = $tooltip($element.find("label"), { title: msg, container: "v3s-document", viewport: '#page-view', placement: 'top auto', trigger: 'hover focus' });


                if (status === answerElement.STATUS.CORRECT) {
                    if (answerElement.completed) {
                        $element.addClass('correct answer');
                    } else {
                        $element.addClass('correct');
                    }
                    
                    var partent = $element.parent()[0];

                    if (!!partent && partent.tagName.toLowerCase() == 'v3s-sc-answer-group') {
                        angular.element(partent).find('input').attr('disabled', 'disabled');
                    } else {
                        $element.find('input').attr('disabled', 'disabled');
                    }
                } else {
                    if (answerElement.getCorrectAnswer() === true) {
                        $element.addClass('wrong answer');
                    } else {
                        if (status === answerElement.STATUS.FALSE) {
                            $element.addClass('wrong');
                        } else if (answerElement.completed) {
                            if (status === answerElement.STATUS.NO_ANSWER) {
                                $element.addClass('wrong');
                            } else {
                                $element.addClass('correct silent');
                            }
                        }
                    }
                }
            }
        }

        if (answerElement.completed) {
            $element.find('input').attr('disabled', 'disabled');
        }
    };
    
    $scope.transcludeFunction = function (clone, directiveScope) {
        angular.forEach(clone, function (node) {
            var tagName = node.tagName.toLowerCase();
            var innerText = node.textContent;

            if (tagName == "v3s-correct") {
                answerElement.setCorrectAnswer(innerText === '1');
            } else if (tagName == "v3s-data") {
                $element.find("label").append(node);
            } else if (tagName == "v3s-fod") {
                fod = innerText;
            } else if (tagName == "v3s-images") {
                var aNode = angular.element(node);
                var imgReleased = aNode.find("v3s-released");
                var imgPressed = aNode.find("v3s-pressed");

                if (!!imgReleased && !!imgPressed) {
                    var pathReleased = v3sContentMediaPath + imgReleased.attr('v3s-file');
                    var pathPressed = v3sContentMediaPath + imgPressed.attr('v3s-file');

                    var styleSheet = $document[0].getElementById('styleTempPage').sheet;
                    styleSheet.insertRule("#" + directiveScope.id + " label {background-image: url(" + pathReleased + ");}", 0);
                    styleSheet.insertRule(" #" + directiveScope.id + " label.active {background-image: url(" + pathPressed + ");}", 0);

                    directiveScope.$on("$destroy", function () {
                        while (styleSheet.cssRules.length > 0) {
                            styleSheet.deleteRule(0);
                        }

                    });

                    var width = parseInt(imgReleased.attr('v3s-width')) || 0;
                    var height = parseInt(imgReleased.attr('v3s-height')) || 0;

                    $element.css('width', width + "px");
                    $element.css('height', height + "px");
                }
                $element.addClass('graphicAnswer');
            }

            $scope.answerElement.setShowFeedback(showFeedbackFunction);

        });
    };


    this.isCorrectAnswer = function () {

    };
    }]);


